import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import AiSearchFloat from "@/components/AiSearchFloat";
import RouteTracker from "@/components/RouteTracker";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Zones from "@/pages/Zones";
import ZoneDetail from "@/pages/ZoneDetail";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ListAsset from "@/pages/ListAsset";
import MarketAnalytics from "@/pages/MarketAnalytics";
import MarketReportDetail from "@/pages/MarketReportDetail";
import ZoneLanding from "@/pages/ZoneLanding";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import { LanguageProvider } from "@/lib/i18n";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <WhatsAppFloat />
      <AiSearchFloat />
    </>
  );
}

function App() {
  return (
    <div className="App bw-sharp">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <RouteTracker />
          <Toaster position="top-right" theme="light" />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/properties" element={<PublicLayout><Properties /></PublicLayout>} />
            <Route path="/properties/:id" element={<PublicLayout><PropertyDetail /></PublicLayout>} />
            <Route path="/zones" element={<PublicLayout><Zones /></PublicLayout>} />
            <Route path="/zones/:slug" element={<PublicLayout><ZoneDetail /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/list-your-asset" element={<PublicLayout><ListAsset /></PublicLayout>} />
            <Route path="/market-analytics" element={<PublicLayout><MarketAnalytics /></PublicLayout>} />
            <Route path="/market-analytics/:slug" element={<PublicLayout><MarketReportDetail /></PublicLayout>} />
            <Route path="/uae" element={<PublicLayout><ZoneLanding /></PublicLayout>} />
            <Route path="/uae/:emirate" element={<PublicLayout><ZoneLanding /></PublicLayout>} />
            <Route path="/uae/:emirate/:zone" element={<PublicLayout><ZoneLanding /></PublicLayout>} />
            <Route path="/uae/:emirate/:zone/:type" element={<PublicLayout><ZoneLanding /></PublicLayout>} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
